import React from 'react';
import { Outlet, Link, useLocation, useNavigate, Navigate } from 'react-router-dom';
import { useAdmin } from '../../contexts/AdminContext';
import './AdminLayout.css';

const AdminLayout = () => {
  const { admin, logout, isAuthenticated, loading } = useAdmin();
  const location = useLocation();
  const navigate = useNavigate();

  // Show loading while checking authentication
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Admin Panel wird geladen...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const menuItems = [
    {
      path: '/admin/dashboard',
      icon: '📊',
      label: 'Dashboard',
      description: 'Genel bakış ve istatistikler'
    },
    {
      path: '/admin/drivers',
      icon: '👥',
      label: 'Taxifahrer',
      description: 'Taxifahrer yönetimi'
    },
    {
      path: '/admin/events',
      icon: '📅',
      label: 'Eventler',
      description: 'Event yönetimi'
    },
    {
      path: '/admin/settings',
      icon: '⚙️',
      label: 'Ayarlar',
      description: 'Sistem ayarları'
    }
  ];

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside className="admin-sidebar">
        <div className="sidebar-header">
          <div className="logo">
            <span className="logo-icon">🚖</span>
            <h2>SuperTaxi Admin</h2>
          </div>
        </div>

        <nav className="sidebar-nav">
          <ul className="nav-menu">
            {menuItems.map((item) => (
              <li key={item.path} className="nav-item">
                <Link
                  to={item.path}
                  className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                >
                  <span className="nav-icon">{item.icon}</span>
                  <div className="nav-content">
                    <span className="nav-label">{item.label}</span>
                    <span className="nav-description">{item.description}</span>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="sidebar-footer">
          <div className="admin-info">
            <div className="admin-avatar">
              <span className="avatar-icon">👤</span>
            </div>
            <div className="admin-details">
              <div className="admin-name">
                {admin?.first_name} {admin?.last_name}
              </div>
              <div className="admin-role">{admin?.role}</div>
            </div>
          </div>
          <button className="logout-btn" onClick={handleLogout}>
            <span className="logout-icon">🚪</span>
            Çıkış
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="admin-main">
        <header className="admin-header">
          <div className="header-left">
            <h1 className="page-title">
              {menuItems.find(item => item.path === location.pathname)?.label || 'Admin Panel'}
            </h1>
            <div className="breadcrumb">
              <span>Admin</span>
              <span className="breadcrumb-separator">›</span>
              <span>{menuItems.find(item => item.path === location.pathname)?.label || 'Page'}</span>
            </div>
          </div>
          
          <div className="header-right">
            <div className="header-info">
              <span className="current-time">
                {new Date().toLocaleDateString('tr-TR', {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </span>
            </div>
          </div>
        </header>

        <div className="admin-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
